import { alpha, Theme } from '@mui/material';

export default {
    menuHolder: {
        '.MuiBackdrop-root': {
            display: 'none',
        },
        '.MuiPaper-root': {
            boxShadow: (theme: Theme) => `0px 4px 4px 0px ${alpha(theme.palette.text.primary, 0.16)}`,
        },
        '.MuiMenu-list': { py: 0 },
    },
    menuItem: {
        display: 'flex',
        py: '6px',
        px: 1.5,
        '&:hover': {
            backgroundColor: (theme: Theme) => alpha(theme.palette.text.primary, 0.04),
            cursor: 'pointer',
        },
    },
    menuItemIcon: {
        display: 'flex',
        flexShrink: 0,
        mr: 1,
    },
    menuItemLabel: {},
};
